import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';
import { UsedSgkd002dSgkd034aService } from '../../../sgkd002d/services/used-sgkd002d-sgkd034a.service';
import { takeUntil } from 'rxjs/operators';
import { Sgkd034aResponse } from 'sg-api';

@Component({
  selector: 'app-sgkd019d-sendto-search',
  templateUrl: './sgkd019d-sendto-search.component.html',
  styleUrl: './sgkd019d-sendto-search.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkd019dSendtoSearchComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  mainForm: UntypedFormGroup;
  /** 送付先検索フォーム */
  searchForm: UntypedFormGroup;

  /** 業務日付 */
  @Input() businessDate: string;

  /** レスポンスエミッター */
  @Output() responseEmitter = new EventEmitter<Sgkd034aResponse>();
  /** メッセージクリアイベント */
  @Output() clearMessageEvent = new EventEmitter();

  constructor(
    private parent: FormGroupDirective,
    private formBuilder: UntypedFormBuilder,
    private usedSgkd002dSgkd034aService: UsedSgkd002dSgkd034aService) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent
   */
  ngOnInit(): void {
    this.mainForm = this.parent.form;
    this.searchForm = this.createForm();
    this.mainForm.addControl('searchForm', this.searchForm);
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    if (this.mainForm) {
      this.mainForm.clearValidators();
      this.mainForm.updateValueAndValidity();
      this.mainForm.removeControl('searchForm');
    }
  }

  /**
   * 請求契約番号検索ボタン押下処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent 
   */
  clickClaimCtrNoSearch(): void {

    // 画面上で以下条件はボタンが押下できないため削除
    // if (this.searchForm.get('claimCtrNo')?.value.length != SgKdConstants.SGKD019D.MAX_LENGTH.CLAIM_CTR_NO) {
    //   return;
    // }

    this.clearMessageEvent.emit();

    // 供給地点特定番号
    this.searchForm.get('suppntSpno').setValue(SgKdConstants.STR.EMPTY);

    this.usedSgkd002dSgkd034aService.doSgkd034a(this.searchForm.get('claimCtrNo')?.value, this.businessDate)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          this.searchForm.get('searchKeyClaimCtrNo').setValue(this.searchForm.get('claimCtrNo').value);
          this.responseEmitter.emit(response);
        }, error => {
        }
      );
  }

  /**
   * 供給地点特定番号検索ボタン押下処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent 
   */
  clickSuppntSpnoSearch(): void {

    // 画面上で以下条件はボタンが押下できないため削除
    // if (this.searchForm.get('suppntSpno')?.value.length != SgKdConstants.SGKD019D.MAX_LENGTH.SUPPNT_SPNO_G &&
    //     this.searchForm.get('suppntSpno')?.value.length != SgKdConstants.SGKD019D.MAX_LENGTH.SUPPNT_SPNO_D) {
    //   return;
    // }

    this.clearMessageEvent.emit();

    // 支払契約番号
    this.searchForm.get('claimCtrNo').setValue(SgKdConstants.STR.EMPTY);

    this.usedSgkd002dSgkd034aService.doSgkd034aWithSuppntSpno(this.searchForm.get('suppntSpno')?.value, this.businessDate)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          this.searchForm.get('searchKeyClaimCtrNo').setValue(SgKdConstants.STR.EMPTY);
          this.responseEmitter.emit(response);
        }, error => {
        }
      );
  }

  /**
   * 請求契約番号クリアボタン押下処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent 
   */
  clickClaimCtrNoClear(): void {
    this.searchForm.get('claimCtrNo').setValue(SgKdConstants.STR.EMPTY);
  }

  /**
   * 供給地点特定番号クリアボタン押下処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent 
   */
  clickSuppntSpnoClear(): void {
    this.searchForm.get('suppntSpno').setValue(SgKdConstants.STR.EMPTY);
  }

  /**
   * 供給地点特定番号入力値変更処理
   * 
   * @memberof Sgkd019dSendtoSearchComponent 
   */
  onChangeSuppntSpno(): void {
    this.searchForm.get('goodsClsfy').setValue(SgKdConstants.STR.EMPTY);
    if (this.searchForm.get('suppntSpno').value === SgKdConstants.STR.EMPTY ||
        !this.searchForm.get('suppntSpno').valid) {
      this.searchForm.get('goodsClsfy').setValue(SgKdConstants.STR.EMPTY);
      return;
    }
    if (this.searchForm.get('suppntSpno').value.length == SgKdConstants.SGKD019D.MAX_LENGTH.SUPPNT_SPNO_G) {
      this.searchForm.get('goodsClsfy').setValue('ガス');
    }
    if (this.searchForm.get('suppntSpno').value.length == SgKdConstants.SGKD019D.MAX_LENGTH.SUPPNT_SPNO_D) {
      this.searchForm.get('goodsClsfy').setValue('電気');
    }
  }


  /**
   * Formの生成処理
   * 
   * @returns 本コンポーネントのForm情報
   * @memberof Sgkd019dSendtoInfoComponent
   */
  private createForm(): UntypedFormGroup {
    let form = this.formBuilder.group({
      /** 請求契約番号 */
      claimCtrNo: new UntypedFormControl({ value: '', disabled: false },
        [
          Validators.minLength(SgKdConstants.SGKD019D.MAX_LENGTH.CLAIM_CTR_NO),
          Validators.maxLength(SgKdConstants.SGKD019D.MAX_LENGTH.CLAIM_CTR_NO),
          Validators.pattern(SgKdConstants.PATTERN.HAN_NUM)
        ]),
      /** 検索キー（請求契約番号） */
      searchKeyClaimCtrNo: new UntypedFormControl({ value: '', disabled: false },
        [
          Validators.required,
          Validators.maxLength(SgKdConstants.SGKD019D.MAX_LENGTH.HAKKOMOTO_ADDR)
        ]),
      /** 供給地点特定番号 */
      suppntSpno: new UntypedFormControl({ value: '', disabled: false },
        [
          //Validators.minLength(SgKdConstants.SGKD019D.MAX_LENGTH.SUPPNT_SPNO_G),
          //Validators.maxLength(SgKdConstants.SGKD019D.MAX_LENGTH.SUPPNT_SPNO_D),
          Validators.pattern(SgKdConstants.PATTERN.SUPPNT_SPNO)
        ]),
      /** 商品種別 */
      goodsClsfy: new UntypedFormControl({ value: '', disabled: true })
    });
    return form;
  }
}
